export default function CardsSection() {
  const cards = [
    {
      title: '动作大片专区',
      desc: '最新好莱坞动作巨制与国产武侠力作，高燃打斗、震撼特效，肾上腺素飙升的观影体验。',
      icon: 'ri-sword-line',
      img: 'https://readdy.ai/api/search-image?query=Dynamic%20action%20movie%20aesthetic%20with%20dramatic%20explosion%20silhouette%2C%20warm%20orange%20and%20amber%20lighting%2C%20cinematic%20composition%2C%20dark%20atmospheric%20background%2C%20professional%20photography%20style%2C%20no%20text%2C%20clean%20simple%20background&width=600&height=400&seq=cards-1-action&orientation=landscape',
    },
    {
      title: '悬疑推理剧场',
      desc: '烧脑悬疑片、高分推理剧合集，环环相扣的剧情让你欲罢不能，挑战你的推理极限。',
      icon: 'ri-search-eye-line',
      img: 'https://readdy.ai/api/search-image?query=Mysterious%20detective%20film%20noir%20atmosphere%20with%20shadowy%20alley%2C%20warm%20streetlamp%20glow%2C%20foggy%20ambiance%2C%20cinematic%20composition%2C%20dark%20moody%20tones%20with%20amber%20highlights%2C%20no%20text%2C%20clean%20simple%20background&width=600&height=400&seq=cards-2-mystery&orientation=landscape',
    },
    {
      title: '喜剧欢乐合集',
      desc: '国内外爆笑喜剧片、综艺搞笑片段精选，承包你一整天的快乐源泉，轻松解压必备。',
      icon: 'ri-emotion-happy-line',
      img: 'https://readdy.ai/api/search-image?query=Bright%20and%20cheerful%20comedy%20film%20visual%20with%20warm%20sunlight%2C%20colorful%20confetti%20elements%2C%20happy%20vibrant%20atmosphere%2C%20cinematic%20composition%2C%20soft%20golden%20lighting%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=cards-3-comedy&orientation=landscape',
    },
    {
      title: '科幻奇幻世界',
      desc: '脑洞大开的科幻巨制与奇幻史诗，带你穿越时空探索未知宇宙，沉浸式视觉盛宴。',
      icon: 'ri-rocket-line',
      img: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20visual%20with%20nebula%20and%20starfield%2C%20warm%20golden%20cosmic%20dust%2C%20abstract%20space%20elements%2C%20cinematic%20composition%2C%20dark%20deep%20space%20background%20with%20amber%20light%20accents%2C%20no%20text%2C%20clean%20simple%20background&width=600&height=400&seq=cards-4-scifi&orientation=landscape',
    },
    {
      title: '动漫番剧天堂',
      desc: '日漫国漫热门番剧同步更新，经典神作与当季新番全覆盖，二次元爱好者的精神家园。',
      icon: 'ri-anchor-line',
      img: 'https://readdy.ai/api/search-image?query=Colorful%20anime%20style%20visual%20with%20vibrant%20illustration%20elements%2C%20warm%20sunset%20sky%2C%20dreamy%20atmosphere%2C%20cinematic%20composition%2C%20soft%20golden%20and%20pink%20tones%2C%20artistic%20style%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=cards-5-anime&orientation=landscape',
    },
    {
      title: '纪录片精选库',
      desc: 'BBC、国家地理等顶级纪录片品牌合集，自然、历史、科技全覆盖，拓展你的知识视野。',
      icon: 'ri-earth-line',
      img: 'https://readdy.ai/api/search-image?query=Nature%20documentary%20visual%20with%20majestic%20landscape%2C%20warm%20golden%20hour%20sunlight%2C%20wildlife%20silhouette%2C%20cinematic%20wide%20shot%2C%20rich%20earthy%20tones%20with%20amber%20highlights%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=cards-6-documentary&orientation=landscape',
    },
    {
      title: '综艺娱乐大全',
      desc: '热门综艺一站看齐，音乐竞演、真人秀、脱口秀应有尽有，周末放松的不二之选。',
      icon: 'ri-tv-line',
      img: 'https://readdy.ai/api/search-image?query=Entertainment%20variety%20show%20visual%20with%20colorful%20stage%20lights%2C%20warm%20spotlight%20beams%2C%20festive%20atmosphere%2C%20cinematic%20composition%2C%20vibrant%20golden%20and%20warm%20tones%2C%20clean%20simple%20background%2C%20no%20text&width=600&height=400&seq=cards-7-variety&orientation=landscape',
    },
  ];

  return (
    <section id="cards" className="py-16 md:py-20 bg-background-100">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold font-heading text-foreground-950 mb-3">
            影视分类导航
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-2xl mx-auto">
            按类型快速找到你想看的影视内容，七大分类覆盖所有观影需求
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-5">
          {cards.map((card, i) => (
            <article
              key={i}
              className={`group bg-background-50 rounded-xl overflow-hidden border border-background-200/60 hover:border-primary-300/40 transition-all duration-300 cursor-pointer ${
                i === 6 ? 'sm:col-span-2 lg:col-span-1 xl:col-span-1' : ''
              }`}
            >
              <div className="relative h-40 md:h-44 overflow-hidden">
                <img
                  src={card.img}
                  alt={card.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-foreground-950/30 to-transparent"></div>
                <div className="absolute top-3 left-3 w-8 h-8 flex items-center justify-center bg-background-50/90 rounded-lg">
                  <i className={`${card.icon} text-sm text-primary-500`}></i>
                </div>
              </div>
              <div className="p-4">
                <h3 className="text-sm md:text-base font-semibold font-heading text-foreground-900 mb-1.5 group-hover:text-primary-500 transition-colors">
                  {card.title}
                </h3>
                <p className="text-xs md:text-sm text-foreground-600 leading-relaxed line-clamp-2">
                  {card.desc}
                </p>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}